export default __webpack_public_path__ + "img/check-grey.5dcd8fef.svg";